import { render, staticRenderFns } from "./GolfProtectionForm.vue?vue&type=template&id=35e30ce7&scoped=true"
import script from "./GolfProtectionForm.vue?vue&type=script&lang=js"
export * from "./GolfProtectionForm.vue?vue&type=script&lang=js"
import style0 from "./GolfProtectionForm.vue?vue&type=style&index=0&id=35e30ce7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e30ce7",
  null
  
)

export default component.exports